import { useTheme } from '@chakra-ui/react'
import React from 'react'
import ButtonMore from '../buttonMore/buttonMore';
import CarouselForComponents from '../carouselCustom/carouselCustom';
// import assets5gestar from '../../innerAsstes/imagenes hero y modulo curso/Asset 5gestar.png';
import '../../App.css'
import { useAppContext } from '../../App';

export default function CarouselLittle({
  children,
  titleFirst,
  titleSecond,
  customStyles = {},
  buttonRedirectTo = ''
}) {
  const theme = useTheme();
  const { isMobile } = useAppContext();
  const style = styles(theme, customStyles, isMobile);
  return (
    <div style={style.container}>
      <div style={style.textContainer}>
        <p style={style.firstText} className='sansation-bold'>
            {titleFirst}
        </p>
        <p style={style.secondText} className='sansation-bold'>
            {titleSecond}
        </p>
        <ButtonMore redirectTo={buttonRedirectTo} customStyles={style.buttonStyles} buttonText='VER TODOS'/>
      </div>
      <CarouselForComponents qtyPerView={isMobile? 1 : 3} customStyles={style.carouselCustomStyles}>
        {children}
      </CarouselForComponents>
    </div>
  );
}

const styles = (theme, customStyles, isMobile) => ({
  container: {
    display: 'flex',
    flexDirection: isMobile? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: "auto",
    paddingTop: 20,
    backgroundColor: theme.background.secondary,
    ...customStyles.container
  },
  textContainer:{
    ...customStyles.textContainer
  },
  firstText: {
    fontSize: '2rem',
    color: theme.color.text.tertiary,
    ...customStyles.titleFirst
  },
  secondText: {
    fontSize: '1.8rem',
    color: theme.color.text.primary,
    ...customStyles.titleSecond
  },
  carouselCustomStyles:{
    width: isMobile? '90%':'70%',
  },
  buttonStyles:{
    container:{
      width: isMobile? '100%':'80%',
      height: '5vh',
      paddingLeft: '0.5rem',
      justifyContent: 'space-around',
    },
    text:{
      fontSize: isMobile? '1rem':'1.5rem',
      width: 'auto',
    },
    arrowSvg:{
      height:'100%',
    }
  }
});
